export function walkUpdateNodeTextContent(node: Node, text: string | ""): string | null | undefined {
    if (node.nodeType === Node.TEXT_NODE || node.childNodes.length === 0) return (node.textContent = text);
    for (const childNode of node.childNodes) {
        if (childNode.nodeType === Node.TEXT_NODE) return (childNode.textContent = text);
        walkUpdateNodeTextContent(childNode, text);
    }
}

export function parseStringToDom(string?: string): Document {
    return new DOMParser().parseFromString(string || "", "text/html");
}
